
<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
      <el-breadcrumb-item>尾程订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="el-card-border" >
      <div slot="header" class="clearfix">
        <div>
          <el-input
            placeholder="请输入提单号"
            v-model="queryList.blNo"
          ></el-input>
          <el-input
            placeholder="请输入柜号"
            v-model="queryList.containerNo"
          ></el-input>
          <el-input
            placeholder="请输入货柜代号"
            v-model="queryList.planName"
          ></el-input>
          <el-select
            placeholder="请选择支付状态"
            v-model="queryList.payStatus"
            clearable
          >
            <el-option label="未支付" value="未支付"></el-option>
            <el-option label="部分支付" value="部分支付"></el-option>
            <el-option label="已支付" value="已支付"></el-option>
          </el-select>
          <el-date-picker
              v-model="queryList.etaRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          <el-button type="warning" @click="query">查询</el-button>
        </div>
      </div>
      <el-table
        :data="wContainerData"
        style="width:100%; overflow-x: auto;"
        stripe
        highlight-current-row
        @row-click="handleRowClick" 
      >
        <el-table-column label="选择" width="50" fixed="left">
          <template slot-scope="scope">
            <el-radio 
            :label="scope.row.id"  
            v-model="currentSelectedId"  
            @change.native.stop 
          >{{ /* 可留空或放图标 */ }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="dispatchType" width="150">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.containerType == '自拼柜' ? 'success' : 'warning'
              "
              disable-transitions
            >
              <span v-if="scope.row.containerType == '自拼柜'">拼柜</span>
              <span v-else>整柜</span>
            </el-tag>
            <el-tag
              :type="scope.row.dispatchType == '0' ? 'primary' : 'warning'"
              disable-transitions
            >
              <span v-if="scope.row.isClearance == '1'">清提派</span>
              <span v-else>提拆派</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" fixed="left" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
            width="120"
            prop="containerLogStatus"
            label="当前状态"
            >
          <template slot-scope="scope">
            <el-link
              :underline="false"
              @click="openDrawer1(scope.$index, scope.row)"
            >
              <span v-if="scope.row.orderLogStatusTxt=='已完成'" style="color:rgb(74, 224, 87);">{{ scope.row.orderLogStatusTxt }}</span>
              <span v-else>{{ scope.row.containerLogStatus }}</span>
              <br>{{ scope.row.containerLogTime || scope.row.createTime | formatDate }}
            </el-link>
          </template>
        </el-table-column>
        
        <el-table-column prop="planName" label="货柜代号" width="140">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content" @click="copy(scope.row.planName)" style="cursor: pointer;">复制</div>
                <el-link type="primary" :underline="false" @click="planOrder(scope.row)" >{{scope.row.planName}}</el-link>
              </el-tooltip>
          </template>
        </el-table-column>       
        <el-table-column prop="containerNo" label="柜号" width="100"></el-table-column>        
        <el-table-column prop="blNo" label="提单号" width="140">
           <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content" @click="copy(scope.row.blNo)" style="cursor: pointer;">复制</div>
                <el-link type="primary" :underline="false" @click="planOrder(scope.row)" >{{scope.row.blNo}}</el-link>
              </el-tooltip>
          </template>
        </el-table-column> 
        <el-table-column prop="totalRealCtn" label="件数"></el-table-column>
        <el-table-column prop="isClearance" label="清否" width="60">
          <template slot-scope="scope">
            <span> {{ scope.row.isClearance=="1" ? "Y":"-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isPick" label="提否" width="60">
            <template slot-scope="scope">
            <span> {{ scope.row.isPick=="1" ? "Y":"-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开船时间" sortable prop="etd" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.etd | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="到港时间" sortable prop="eta" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.eta | formatDate }}</span>
          </template>
        </el-table-column>        
        <el-table-column label="清关时间" sortable prop="eta" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.eta | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提柜时间" sortable prop="pickupTime" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.pickupTime | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="还柜时间" sortable prop="pickupTime" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.pickupTime | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pol" label="起运港口"></el-table-column>
        <el-table-column prop="podEnd" label="目的港口"></el-table-column>
        <el-table-column prop="shipNo" label="船名航次"></el-table-column>
        <el-table-column prop="money" label="总费用" fixed="right"></el-table-column>
        <el-table-column prop="payStatus" label="支付状态" fixed="right">
          <template #default="{ row }">
            <el-tag 
              :type="getTagType(row.payStatus)" 
              size="small">
              {{ getPayStatusText(row.payStatus) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页功能 -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    
    <el-drawer title="最新物流状态" :visible.sync="drawer1" :with-header="false" >
        <div class="drawer-box">
          <p>柜子物流进度</p>
          <el-timeline style="overflow-y: auto;height: 600px;float: left;display:contents;" >
              <el-timeline-item
                v-for="(item, index) in schedule1"
                :key="index"
                :icon="item.icon"
                :size="item.size"
                :type="item.type"
                :color="index === 0 ? '#ff0000' : ''"
              >
                <span style="margin-left:1px;">{{item.createTime2  |formatDate}}</span>
                <br /><b>{{item.content}}</b>
              </el-timeline-item>
            </el-timeline>
        </div>
      </el-drawer>
  </div>
</template>

<script>
import httpApi from '@/http/api'
//引入时间函数
import { formatTimeToStr } from "@/util/toLocaleString.js";
//引入select
import Fbacode from "@/components/select/Fbacode";
import Contype from "@/components/select/Contype";
import Port from "@/components/select/Port";

export default {
  name: "WContainer",
  components: {
    Fbacode, //fba
    Contype, //柜型
    Port, //港口
  },
  data() {
    return {
      wContainerData: [],
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      drawer1: false,
      schedule1: [],
      logisticsStatus: [],
      deleteId: '', //删除id号
      planName: '', //货柜代码
      orderRadio: '', //选择的订单
      orderNo: '', //订单号
      clientNo: '', //运单号
      contOrderData: [], //柜子里的订单数据
      dialogFormVisible: false,
      title: "", // 弹出层标题
      currentSelectedId: null,
      ruleForm: {
        id: undefined,
        dispatchType: undefined,
        pol: undefined,
        podEnd: undefined,
        size: undefined,
        fbacode: undefined,
        type: undefined,
        userId: undefined,
        username: undefined,
        containerNo: undefined,
        eta: undefined,
        etd: undefined,
        shipNo: undefined,
        sellerId: undefined,
        sellerName: undefined,
        containerId: undefined,
      },
      radio: undefined, // 单选框
      planNameSelect: undefined, //当前选择的柜子的货柜代号
      userSelect: {
        userId: undefined,
        username: undefined,
        sellerId: undefined,
        sellerName: undefined,
        containerId:undefined,
      },
      isEdit: false, //是否编辑

      Types: [
        {
          label: "海运 ",
          value: "0",
        },
        {
          label: "空运",
          value: "1",
        },
      ],
      dispatchType: [
        {
          label: "直送 ",
          value: "0",
        },
        {
          label: "拆柜",
          value: "1",
        },
      ],
      queryList: {
        userId: undefined,
        containerNo: undefined,
        planName: undefined,
        blNo: "",
        payStatus: "",
        etaRange: [],
      },

      rules: {
        dispatchType: [
          { required: true, message: "请选择方式", trigger: "change" },
        ],
        size: [{ required: true, message: "请选择柜型", trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        pol: [{ required: true, message: "请选择起运港", trigger: "change" }],
        podEnd: [
          { required: true, message: "请选择目的港", trigger: "change" },
        ],
        fbacode: [
          { required: false, message: "请选择fbacode", trigger: "change" },
        ],
        userId: [{ required: true, message: "请选择客户", trigger: "change" }],
        containerNo: [
          { required: true, message: "请输入柜号", trigger: "change" },
        ],
        eta: [{ required: true, message: "请输入Eta", trigger: "change" }],
        etd: [{ required: true, message: "请输入Etd", trigger: "change" }],
      },
      containerList: {},
    };
  },

  methods: {
     //根据不同状态显示不同颜色
    getTagType(status) {
      const statusMap = {
        '已支付': { text: '已支付', type: 'success' },  // 绿色
        '未支付': { text: '未支付', type: 'danger' },   // 红色
        '部分支付': { text: '部分支付', type: 'warning' }, // 黄色
        '': { text: '未支付', type: 'danger' }          // 空状态处理
      }
      // 获取匹配的状态，默认为灰色info
      const matchedStatus = statusMap[status] || { text: status, type: 'info' }
      // 更新支付状态文本
      this.wContainerData.payStatus = matchedStatus.text
      return matchedStatus.type
    },
     getPayStatusText(status) {
      return status || '未支付' // 空值显示为"未支付"
    },

    handleRowClick(row) {
      this.currentSelectedId = row.id;  // 设置当前选中ID
      this.handleSelectionChange(row);  
    },
    
    handleSelectionChange(row) {
      this.selectedRow = row;
    },
    init() {
      let that = this;
      this.radio = undefined;
      this.planNameSelect = undefined;
      this.userSelect = {
        userId: undefined,
        username: undefined,
        sellerId: undefined,
        sellerName: undefined,
        containerId: undefined,
      }
      httpApi
        .findWContaienr({
          params: {
            userId: that.queryList.userId,
            containerNo: that.queryList.containerNo,
            planName: that.queryList.planName,
            type: true,
            page: that.currentPage,
            rows: that.pagesize,
          },
        })
        .then((res) => {
          console.log(res);
          
          if (res.data.code == "ok") {
            that.wContainerData = res.data.data.rows;
            that.total = res.data.data.total;
          }
        });
    },

    //打开物流抽屉
    openDrawer1(index, row){
      let that = this;
      httpApi
        .containerLogistics( {
          params: { planName: row.planName }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.schedule1 = res.data.data;
          } else {
            that.$message.error(res.data.message);
          }
        });
      this.drawer1 = true;
    },
    //跳往柜子订单
    planOrder(row) {
    this.$router.push({
      path: "/WCaborder/"+row.planName

    });
    },
    //柜子选择
    rowClick(column) {
    this.radio = this.cabData.findIndex((item) => {
      //拿到当前行在数组的下标
      return item.id == column.id
    })
    this.planName = column.planName
    this.containerId = column.id
    let that = this
    httpApi
      .listContorder( {
        params: {
          containerId: that.containerId,
          rows: 100000
        },
      })
      .then((res) => {
        if (res.data.code == 'ok') {
          that.contOrderData = res.data.data.rows
        } else {
          that.$message.warning(res.data.message)
        }
      })
    },
    query() {
      this.pagesize = 20;
      this.currentPage = 1;
      this.init();
    },
    //柜型
    getSize(e) {
      this.ruleForm.size = e;
    },
    //fbacode新增
    getCode(e) {
      this.ruleForm.fbacode = e;
    },
    getUser(e) {
      if (e != undefined) {
        this.ruleForm.userId = e.id;
        this.ruleForm.username = e.username;
        this.ruleForm.sellerId = e.sellerId;
        this.ruleForm.sellerName = e.sellerName;
        this.ruleForm.containerId = e.containerId;
      } else {
        this.ruleForm.userId = undefined;
        this.ruleForm.username = undefined;
        this.ruleForm.sellerId = undefined
        this.ruleForm.sellerName = undefined;
        this.ruleForm.containerId = undefined;
      }
    },
    //查询获取客户id
    getUserId(e) {
      if (e != undefined) {
        this.queryList.userId = e.id;
      } else {
        this.queryList.userId = undefined;
      }
    },
    //出运港
    getPol(e) {
      this.ruleForm.pol = e;
    },
    //目的港
    getPnd(e) {
      this.ruleForm.podEnd = e;
    },

    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.init();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
    },
    handleCurrentChange1(val) {
      if(val != undefined){
        this.planNameSelect = val.planName;
        this.userSelect.userId = val.userId;
        this.userSelect.username = val.username;
        this.userSelect.sellerId = val.sellerId;
        this.userSelect.sellerName = val.sellerName;
        this.userSelect.containerId = val.id;

      this.radio = this.wContainerData.findIndex((item) => {
        //拿到当前行在数组的下标
        return item.id == val.id
      })
      }
    },
  },
  created() {
    this.init();
  },
  filters: {
    formatDate: function (time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        return formatTimeToStr(date, "yyyy-MM-dd");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>

.el-card-border .el-input,
.el-card-border .el-select,
.el-card-border .el-date-picker {
  margin-right: 10px; /* 水平间距 */
}
.el-card-border .el-input:last-child,
.el-card-border .el-select:last-child,
.el-card-border .el-date-picker:last-child {
  margin-right: 0;
}

/deep/.el-radio__label {
  display: none;
}
.drawer-box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;
  p:first-child{
    font-size: 20px;
    margin-bottom: 20px;
  }
  p:last-child{
    font-size: 16px;
    color: red;
  }
}

</style>